import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "../styles/ModalConfirmacao.module.scss";

/**
 * Modal generico de confirmacao com animacao de abertura/fechamento.
 *
 * @param {boolean} aberto - Controla a visibilidade do modal
 * @param {Function} onFechar - Callback para fechar o modal
 * @param {string} titulo - Titulo do modal
 * @param {string|React.ReactNode} descricao - Descricao/conteudo do modal
 * @param {string} texto_confirmar - Texto do botao de confirmar
 * @param {string} texto_cancelar - Texto do botao de cancelar (default: "Voltar")
 * @param {"danger"|"primary"} variante_confirmar - Variante visual do botao de confirmar
 * @param {boolean} loading - Indica se ha uma requisicao em andamento
 * @param {Function} onConfirmar - Callback ao confirmar
 */
export default function ModalConfirmacao({
  aberto,
  onFechar,
  titulo,
  descricao,
  texto_confirmar,
  texto_cancelar = "Voltar",
  variante_confirmar = "danger",
  loading = false,
  onConfirmar,
}) {
  const [visivel, setVisivel] = useState(aberto);
  const [saindo, setSaindo] = useState(false);

  useEffect(() => {
    if (aberto) {
      setVisivel(true);
      setSaindo(false);
    } else if (visivel) {
      setSaindo(true);

      const timer = setTimeout(() => {
        setVisivel(false);
        setSaindo(false);
      }, 220);

      return () => clearTimeout(timer);
    }
  }, [aberto]);

  if (!visivel) {
    return null;
  }

  const classe_botao_confirmar = variante_confirmar === "danger"
    ? styles.botaoConfirmarDanger
    : styles.botaoConfirmarPrimary;

  return ReactDOM.createPortal(
    <div className={`${styles.overlay} ${saindo ? styles.saindo : ""}`} onClick={onFechar}>
      <div className={`${styles.modal} ${saindo ? styles.modalSaindo : ""}`} onClick={(evento) => evento.stopPropagation()}>
        <div className={styles.modalBody}>
          <p className={styles.titulo}>{titulo}</p>
          <p className={styles.descricao}>{descricao}</p>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.botaoCancelar} onClick={onFechar} disabled={loading}>
            {texto_cancelar}
          </button>

          <button className={classe_botao_confirmar} onClick={onConfirmar} disabled={loading}>
            {loading ? "Aguarde..." : texto_confirmar}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
